import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { FieldValues, UseFormMethods } from 'react-hook-form';
import { UrlInput } from '../../common/formFields/UrlInput';
import { ILegalInProcessDetails } from '../types';

interface ILegalInProcessDetailsEditFormProps {
  form: UseFormMethods<FieldValues>;
  details?: ILegalInProcessDetails;
}

const LegalInProcessDetailsEditForm = (props: ILegalInProcessDetailsEditFormProps): JSX.Element => {
  const { form, details } = props;
  const { control } = form;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 10 }}>
        <UrlInput
          control={control}
          name="accountingPlanLink"
          label="Accounting Plan Link"
          defaultValue={details?.accountingPlanLink}
          placeholder="https://microsoft.sharepoint.com/..."
        />
      </Stack>
    </FluentProvider>
  );
};

export default LegalInProcessDetailsEditForm;
